import { useState, useRef } from "react";
import './App.css';
import StickyNote from "./comp/StickyNote";
import Page from "./comp/Page";
import Folder from "./comp/Folder";
import DeviceRedirect from "./comp/DeviceRedirect";

function App() {
    const TOTAL_PAGES = 5;
    const draggingRef = useRef(false);
    const offsetRef = useRef({ x: 0, y: 0 });
    const noteRef = useRef(null);

    const [position, setPosition] = useState({x: "50%", y: "52.5%"});
    const [index, setIndex] = useState(0);
    const [pfpInteract, setPfpInteract] = useState(false);

    const handleMouseDown = (e) => {
        if (!e.target.closest(".pfp")) return;
        draggingRef.current = true;
        const rect = noteRef.current.getBoundingClientRect();
        offsetRef.current = { x: e.clientX - rect.left, y: e.clientY - rect.top };

        window.addEventListener("mousemove", handleMouseMove);
        window.addEventListener("mouseup", handleMouseUp);
    };
    const handleMouseMove = (e) => {
        if (!draggingRef.current) return;
        setPosition({
            x: e.clientX - offsetRef.current.x + 100,
            y: e.clientY - offsetRef.current.y
        });
        window.getSelection().removeAllRanges();
    };
    const handleMouseUp = () => {
        draggingRef.current = false;
        window.removeEventListener("mousemove", handleMouseMove);
        window.removeEventListener("mouseup", handleMouseUp);
    };
    const style = {
        left: position.x,
        top: position.y,
    };

    return (
        <>
            <DeviceRedirect />
            <div className="App">
                <header>
                    <h1 onClick={()=>{setIndex(0)}}>McCarty.Cam</h1>
                </header>
                <StickyNote pos={{x: "47%", y: "47%"}} draggable={true}>
                    <nav>
                        <ul>
                            <li><div className="navBtn" onClick={()=>{setIndex(0)}}>Welcome</div></li>
                            <li><div className="navBtn" onClick={()=>{setIndex(1)}}>About</div></li>
                            <li><div className="navBtn" onClick={()=>{setIndex(2)}}>Portfolio</div></li>
                            <li><div className="navBtn" onClick={()=>{setIndex(3)}}>Skills</div></li>
                            <li><div className="navBtn" onClick={()=>{setIndex(4)}}>Contact</div></li>
                        </ul>
                    </nav>
                </StickyNote>
                <Page idx={0} currentIdx={index} setIndex={setIndex} total={TOTAL_PAGES}>
                    <h2>Cameron McCarty</h2>
                    <h3>Full-Stack Software Engineer</h3>
                    <div className="hr"></div>
                    <p>Full-stack software engineer with 3 years of experience building web applications with React and Node. Experience in frontend, backend, database systems, and Agile methodologies. Proven ability to lead projects and maintain customer relations.</p>
                    <div className={pfpInteract ? "pfp interacted" : "pfp"} onMouseDown={()=>{setPfpInteract(true)}}>
                        <div className="pfpImg"></div>
                        <h4>Cameron McCarty</h4>
                    <div className="slit top"></div>
                    <div className="slit bottom"></div>
                    </div>
                </Page>
                <Page idx={1} currentIdx={index} setIndex={setIndex} total={TOTAL_PAGES}>
                    <h2>About</h2>
                    <h3>Education</h3>
                    <div className="hr"></div>
                    <h4>BS in Information Technology</h4>
                    <h5 className="justifiedHeader"><span>Liberty University</span><span className="spacer"></span><span>Graduated 07/2025</span></h5>
                    <hr />
                    <p>Cognate in Web and Mobile Programming</p>
                    <p>Summa Cum Laude, 4.0 GPA, Dean's List</p>
                    <br />
                    <h4>AAS in Web Development</h4>
                    <h5 className="justifiedHeader"><span>Collin College</span><span className="spacer"></span><span>Graduated 12/2023</span></h5>
                    <hr />
                    <p>Summa Cum Laude, 4.0 GPA, Dean's List</p>
                    <br />
                    <h3>Work Experience</h3>
                    <div className="hr"></div>
                    <h4>Best Buy Geek Squad</h4>
                    <hr />
                    <h5 className="justifiedHeader"><span>Consultation Agent</span><span className="spacer"></span><span>09/2025 - Present</span></h5>
                    <ul>
                        <li>Provided technical support and troubleshooting for hardware/software issues</li>
                        <li>Maintained knowledge and skillsets through certified training courses</li>
                        <li>Communicated complex technical information clearly to non-technical clients</li>
                    </ul>
                    <h4>Code78 LLC / Independent Contractor</h4>
                    <hr />
                    <h5 className="justifiedHeader"><span>Co-Founder & Software Engineer</span><span className="spacer"></span><span>04/2023 - Present</span></h5>
                    <ul>
                        <li>Built inventory management system for small businesses</li>
                        <li>Developed and maintained e-commerce websites through Content Management Systems</li>
                        <li>Maintained codebases, Git repositories, and documentation for multiple projects</li>
                    </ul>
                </Page>
                <Folder idx={2} currentIdx={index} setIndex={setIndex} title="Portfolio" total={TOTAL_PAGES} />
                <Page idx={3} currentIdx={index} setIndex={setIndex} total={TOTAL_PAGES}>
                    <h2>Skills</h2>
                    <h3>Technical Skills</h3>
                    <div className="hr"></div>
                    <ul>
                        <li><strong>Languages:</strong> React, JavaScript, HTML5, CSS, Node.js, Express.js, Python, Java, C++, C#</li>
                        <li><strong>AI-Assisted Development:</strong> Claude Code and AI coding agents to architect, build, and ship full applications</li>
                        <li><strong>Databases:</strong> SQL, MySQL, PostgreSQL, MongoDB, Microsoft SQL Server</li>
                        <li><strong>Systems:</strong> Windows 10/11, Windows Server, macOS, Linux, RESTful APIs</li>
                        <li><strong>Platforms/CMS:</strong> WordPress + Elementor, GoDaddy, Squarespace, Square</li>
                        <li><strong>Networking:</strong> TCP/IP, DNS, DHCP, Home/Small-business LANs</li>
                        <li><strong>Tools:</strong> Git, Adobe Photoshop, Microsoft Office, Computer hardware repair</li>
                    </ul>
                    <h3>General Skills</h3>
                    <div className="hr"></div>
                    <ul>
                        <li>English (native), Spanish (conversational), French (conversational/reading)</li>
                        <li>Microsoft Office suite (Word, Excel, PowerPoint, etc.)</li>
                        <li>Leadership and Training</li>
                        <li>Attention to detail, Problem-solving, and Innovation</li>
                    </ul>
                    <h3>Certifications</h3>
                    <div className="hr"></div>
                    <ul>
                        <li>Full-stack Web Developer Certificate Level 2</li>
                        <li>Web Development Fundamentals Certificate Level 1</li>
                        <li>JavaScript Development Occupational Skill Award</li>
                    </ul>
                </Page>
                <Page idx={4} currentIdx={index} setIndex={setIndex} total={TOTAL_PAGES}>
                    <h2>Contact</h2>
                    <br />
                    <iframe title="Contact form" src="https://forms.gle/vutt2Hy4nPkPjXm36" frameBorder="0"></iframe>
                </Page>
                <div ref={noteRef} style={style} onMouseDown={handleMouseDown} className={pfpInteract ? "pfp" : "pfp interacted"}>
                    <div className="pfpImg"></div>
                    <h4>Cameron McCarty</h4>
                </div>
            </div>
        </>
    );
}

export default App;
